<ng-container>
  <div class="-top-12 right-0 p-2 flex items-end justify-end w-24 h-24 z-10 absolute" (click)="openModal()">
    <div class="text-white flex items-center justify-center rounded-full">
      <svg class="h-8 w-8 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
  </div>
  <ng-content></ng-content>
  <vti-modal [visible]="showModal()" closable (onClose)="closeModal()">
    <ng-template #content>
      <div class="w-80 sm:w-full">
        <p class="font-bold">{{ modalTitle() }}</p>
        <div class="mt-4">
          <span [innerHTML]="modalDescription()"></span>
        </div>
      </div>
    </ng-template>
  </vti-modal>
</ng-container>
